// File: client/src/components/analytics/ProgressBar.js
import React from 'react';
import { getScoreColor } from './scoreUtils';

function ProgressBar({ label = '', value = 0, displayAsPercentage = true, maxValue = 100 }) {
    // Calculate percentage for visual representation (always 0-100 for fill)
    const percentage = Math.min(100, Math.max(0, (value / maxValue) * 100));
    const { gradient } = getScoreColor(percentage);
    const gradientId = `bar-gradient-${label.replace(/\s+/g, '')}-${Math.round(percentage)}`;

    // Determine display value based on toggle
    const displayValue = displayAsPercentage ? `${percentage.toFixed(1)}%` : value.toFixed(1);

    return (
        <div style={{ marginBottom: '16px' }}>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: '6px',
                    fontSize: '14px',
                    color: '#6b7280',
                }}
            >
                <span>{label}</span>
                <span>{displayValue}</span>
            </div>
            <div
                style={{
                    height: '6px',
                    background: '#f3f4f6',
                    borderRadius: '3px',
                    overflow: 'hidden',
                }}
            >
                <div
                    style={{
                        width: `${percentage}%`,
                        height: '100%',
                        background: `linear-gradient(to right, ${gradient[0]}, ${gradient[1]})`,
                        borderRadius: '3px',
                        transition: 'width 0.3s ease',
                    }}
                />
            </div>
        </div>
    );
}

export default ProgressBar;
